import { render, staticRenderFns } from "./OAuthCallbackView.vue?vue&type=template&id=610948d4&scoped=true"
import script from "./OAuthCallbackView.vue?vue&type=script&lang=js"
export * from "./OAuthCallbackView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610948d4",
  null
  
)

export default component.exports